import { c } from 'ttag';
import { OPEN_NOTE_HISTORY_COMMAND } from '@standardnotes/ui-services';
import { action, makeObservable, observable } from 'mobx';
import { AbstractViewController } from '../Abstract/AbstractViewController';
export class HistoryModalController extends AbstractViewController {
    deinit() {
        super.deinit();
        this.note = undefined;
    }
    constructor(notesController, commandService, eventBus) {
        super(eventBus);
        this.note = undefined;
        this.setNote = (note) => {
            this.note = note;
        };
        this.openModal = (note) => {
            this.setNote(note);
        };
        this.dismissModal = () => {
            this.setNote(undefined);
        };
        makeObservable(this, {
            note: observable,
            setNote: action,
        });
        this.disposers.push(commandService.addWithShortcut(OPEN_NOTE_HISTORY_COMMAND, 'Current note', c('B4.Notes.History.Action').t `Open note history`, () => {
            this.openModal(notesController.firstSelectedNote);
            return true;
        }));
    }
}
